/**
 * Tradutor de erros de autenticação do Supabase para Português (Brasil)
 */
export const translateAuthError = (message: string): string => {
  if (!message) return 'Ocorreu um erro desconhecido.';
  const lower = message.toLowerCase();
  
  if (lower.includes('invalid login credentials') || lower.includes('invalid credentials')) {
    return 'E-mail ou senha incorretos. Por favor, verifique os dados digitados.';
  }
  if (lower.includes('email not confirmed') || lower.includes('email_not_confirmed')) {
    return 'Seu e-mail ainda não foi confirmado. Por favor, verifique sua caixa de entrada e spam para ativar sua conta.';
  }
  if (lower.includes('user already registered') || lower.includes('already exists') || lower.includes('email already in use')) {
    return 'Este e-mail já está cadastrado. Tente fazer login ou recuperar sua senha.';
  }
  if (lower.includes('password should be') || lower.includes('password is too short') || lower.includes('password should be at least')) {
    return 'A senha deve conter pelo menos 6 caracteres.';
  }
  if (lower.includes('rate limit') || lower.includes('too many requests') || lower.includes('over_query_limit')) {
    return 'Muitas tentativas em pouco tempo. Por favor, aguarde alguns minutos e tente novamente.';
  }
  if (lower.includes('user not found') || lower.includes('cannot find user') || lower.includes('invalid user')) {
    return 'Usuário não encontrado. Verifique se digitou o e-mail corretamente.';
  }
  if (lower.includes('invalid email') || lower.includes('email address is invalid') || lower.includes('email must be a valid')) {
    return 'Por favor, insira um endereço de e-mail válido.';
  }
  if (lower.includes('network') || lower.includes('failed to fetch')) {
    return 'Erro de conexão de rede. Verifique sua conexão com a internet.';
  }
  if (lower.includes('signup is disabled') || lower.includes('signups are disabled')) {
    return 'Os cadastros de novos usuários estão temporariamente desativados.';
  }
  if (lower.includes('token has expired') || lower.includes('confirmation token') || lower.includes('token is invalid')) {
    return 'O token ou link de confirmação expirou ou é inválido. Por favor, tente novamente ou solicite um novo link.';
  }
  if (lower.includes('same as current') || lower.includes('different from current')) {
    return 'A nova senha deve ser diferente da senha atual.';
  }
  if (lower.includes('phone') && lower.includes('invalid')) {
    return 'Por favor, insira um número de telefone válido.';
  }
  
  return message;
};
